import { createCustomEnum } from "./customEnum";

// On Review: same options from PartnerTypes enum, but less
const AgentOfficePartnerTypes = createCustomEnum({
	Association: {
		value: 6,
		name: "Association",
		displayName: "Association",
	},
	InsideSalesOffice: {
		value: 3,
		name: "InsideSalesOffice",
		displayName: "Inside Sales Office",
	},
	ISV: {
		value: 8,
		name: "ISV",
		displayName: "ISV",
	},
	OutsideSalesAgentIndependent: {
		value: 10,
		name: "OutsideSalesAgentIndependent",
		displayName: "Outside Sales Agent (Independent)",
	},
	OutsideSalesOffice: {
		value: 2,
		name: "OutsideSalesOffice",
		displayName: "Outside Sales Office",
	},
	ReferralPartner: {
		value: 7,
		name: "ReferralPartner",
		displayName: "Referral Partner",
	},
});

export default AgentOfficePartnerTypes;
